import React, { Component } from 'react';
import { Row, Col,Button  } from 'antd';
import { Link } from 'react-router-dom';
import $ from "jquery";
import {burritoAPIs} from '../../apiCalls/index'
import { sum } from 'lodash'


var orderDetailsLocalObj = [];
var temporderDetailsLocalObj = [];
var countTotal = 0;
class MyOrder extends Component {
    state = { 
   
    };
   constructor(props){ 
    super(props);
    this.state = {
        orderDetailsObj:JSON.parse(localStorage.getItem("orderDetailsLocalObj") || "[]"),
        idObj:'',
        countTotalState:'',
        countArray:[],
        loading: false,
    }
  }     
    componentDidMount(){        
    const { orderDetailsObj , countArray} = this.state;
    const { orderdetails } = orderDetailsObj;    
       for (var i=0; i < orderdetails.length; i++) {
        countArray.push(Number(orderdetails[i].item.price))        
       }
      console.log('countArray', countArray);
    
     this.setState({
         countTotalState : sum(countArray)
     })
    }

     incrementValue(e,itemOrderId,oneUnitPriceVar) {
       
        var fieldName = $(e.target).data('field');
        var parent = $(e.target).closest('div');
        var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
      
        if (!isNaN(currentVal)) {
          parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
        } else {
          parent.find('input[name=' + fieldName + ']').val(0);
        }

        const { orderDetailsObj , countArray} = this.state;
        const { orderdetails } = orderDetailsObj;

        for (let i=0; i < orderdetails.length; ++i) {
            if (orderdetails[i].item.itemOrderId == itemOrderId) {
                orderdetails[i].item.quantity++
                orderdetails[i].item.price = Number(orderdetails[i].item.price) + oneUnitPriceVar
            }
          }
        this.setState({
            orderDetailsObj: this.state.orderDetailsObj
        })

        localStorage.setItem("orderDetailsLocalObj", JSON.stringify(orderDetailsObj));
        this.setState({
            orderDetailsObj: JSON.parse(localStorage.getItem("orderDetailsLocalObj") || "[]"),
        })
        this.getTotal();
        // for (var i=0; i < orderdetails.length; i++) {
        //     this.setState({
        //         countTotalState : oneUnitPriceVar + orderdetails[i].item.price
        //     })      
        // }
        
       
      }
      
       decrementValue(e, itemOrderId, oneUnitPriceVar) {
        let valQuantity =  $('.quantity-field').val();
        if(Number(valQuantity) == 0){
         return;
        }
        e.preventDefault();
        var fieldName = $(e.target).data('field');
        var parent = $(e.target).closest('div');
        var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);
      
        if (!isNaN(currentVal) && currentVal > 0) {
          parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
        } else {
          parent.find('input[name=' + fieldName + ']').val(0);
        }

        const { orderDetailsObj, countArray} = this.state;
        const { orderdetails } = orderDetailsObj;
         
        for (let i=0; i < orderdetails.length; ++i) {
            if (orderdetails[i].item.itemOrderId == itemOrderId) {
                orderdetails[i].item.quantity--   
                orderdetails[i].item.price = Number(orderdetails[i].item.price) - oneUnitPriceVar            
            }
          }
          this.setState({
            orderDetailsObj: this.state.orderDetailsObj
        })

        localStorage.setItem("orderDetailsLocalObj", JSON.stringify(orderDetailsObj));
        this.setState({
            orderDetailsObj: JSON.parse(localStorage.getItem("orderDetailsLocalObj") || "[]"),
        })
        this.getTotal();
        // for (var i=0; i < orderdetails.length; i++) {
        //     this.setState({
        //         countTotalState : oneUnitPriceVar - orderdetails[i].item.price
        //     })      
        // }
        
      }
      getTotal(){
        var fromTotal = JSON.parse(localStorage.getItem("orderDetailsLocalObj") || "[]")
        var finalArray = []
        for (var i=0; i < fromTotal.orderdetails.length; i++) {
            finalArray.push(Number(fromTotal.orderdetails[i].item.price))        
           }

           console.log('final', sum(finalArray))
           this.setState({
            countTotalState : sum(finalArray)
        })
      }

      deleteItem(id){
        const { orderDetailsObj ,countTotalState} = this.state;
        const { orderdetails } = orderDetailsObj; 
        for (let i=0; i < orderdetails.length; ++i) {
            if (orderdetails[i].item.itemOrderId == id) {               
                orderdetails.splice(i, 1);               
            }
          }      
       
        this.setState({
            orderDetailsObj: this.state.orderDetailsObj,           
        })
        localStorage.setItem("orderDetailsLocalObj", JSON.stringify(orderDetailsObj));
        window.location.reload();
        
        this.componentDidMount();
        // for (var i=0; i < orderDetailsLocalObj.length; i++) {
        //     countTotal = Number(countTotal) +  Number(orderDetailsLocalObj[i].item.price)
        //    }
      }
      goToMenu(){
          this.props.history.push({
            pathname: '/menu'              
        });
        }

      placeOrder(){
        var excludeItems = JSON.parse(localStorage.getItem("excludeItems") || "[]")
        this.setState({ loading: true });
        var objTobeSent = {};
        const { orderDetailsObj , countTotalState} = this.state;
        const { orderdetails } = orderDetailsObj; 
       
        objTobeSent.price = countTotalState ;
        objTobeSent.orderdetails = orderdetails;
        objTobeSent.excludeItems = excludeItems;

        //orderDetailsObj.price = countTotalState
        burritoAPIs.placeOrder(objTobeSent).then((responsevar) => {
            this.setState({ loading: false });
            console.log('All orderDetailsLocalObj', responsevar);
            localStorage.setItem('TotalFinalPrice',countTotalState);
            localStorage.setItem("TotalFinalOrder", JSON.stringify(objTobeSent));
            this.props.history.push({
                pathname: '/payment'              
            });
        }).catch((errorMsg) => {
            console.log(errorMsg);
            this.setState({ loading: false });
        });   
      }
    render() { 

        const { orderDetailsObj , countTotalState} = this.state;
        const { orderdetails } = orderDetailsObj;
        return ( 
            <React.Fragment>
            <div className='menu-page'>
            <div className='menu-static-upper'>
            <Link to='/home'>
            <span className='home-ico'>
            <i className='fa fa-home'></i>
            </span>
            </Link>
            
            <div className='menu-head'>Burrito Bar
            {/* {this.state.idObj} */}
            </div>
            <div style={{textAlign:'center',marginTop:'60px'}}>
            <Button className='round-white-btn' onClick={()=>this.goToMenu()}>
            Menu
            </Button>  
            <Button                                
            className='round-orange-btn'>
            My Order
            </Button>  
            </div>
            </div>

            <div className='order-btm'>
            <div className='mini-orange' style={{paddingBottom:'30px'}}>
            Verify your order details below
            </div>

             {orderdetails.map((itemsRetval, idx) =>
            <div className='cart-box'>
            <Row gutter={16} style={{marginBottom:'15px'}}>
            <Col span={15}>
            <div className='item-name'>{itemsRetval.item.itemName}</div>
            {/* <div className='item-para'>Ground Beef, Rice, Cheese 
                and Sour Cream</div> */}
                {itemsRetval.item.extras.map((itemIngredients, idx) =>
                <div className='light-font'>
            <span className='dot'>
            <img height='' width='' src={require('../../assets/img/blackdot.png')}/> 
            </span>
            
          <span>{itemIngredients.extraItemName}</span>
          <span style={{fontWeight:'bold'}}>   x{itemIngredients.count}</span>

           </div>
        )}
            </Col> 
            <Col span={9}>
            <div class="counter">
            <input
            onClick={(e) => {
            this.decrementValue(e,itemsRetval.item.itemOrderId ,itemsRetval.item.oneUnitPrice)
            }}               
            type="button" value="-" class="button-minus btn-count" data-field="quantity"/>
            <input type="number" step="1" max=""  value={itemsRetval.item.quantity} name="quantity" class="quantity-field"/>
            <input
            onClick={(e) => {
            this.incrementValue(e,itemsRetval.item.itemOrderId, itemsRetval.item.oneUnitPrice)
            }}
            type="button" value="+" class="button-plus btn-count" data-field="quantity"/>
            </div>
            </Col>      
    
            </Row>

            <Row gutter={16} style={{marginBottom:'15px'}}>
            
            </Row>

            <Row>
                <Col span={12}>
                <span
                onClick={() => this.deleteItem(itemsRetval.item.itemOrderId)}
                className='trash-ico'>
            <i className='fa fa-trash'></i>
            </span></Col>
                <Col span={12}>                 

            <span className='big-price'>
            $ {Number(itemsRetval.item.price).toFixed(2)}   
            </span></Col>

            </Row>
            </div>
            )} 

            <Row>
                <Col span={12}>
                <span className='reg-black'>
                Total (incl. tax):
            </span></Col>
                <Col span={12}>                 

            <span className='big-price'>
           $ {Number(countTotalState).toFixed(2)}  
            </span></Col>

            </Row>
           
            <div style={{marginTop:'3em',textAlign:'center'}}>
            <Button
            loading={this.state.loading}
            onClick={() => this.placeOrder()}
            style={{width:'313px',margin:'0 auto'}} className='place-order'>
            Place Order
            </Button>
            </div>
      
            </div>
            </div>    
            </React.Fragment>
         );
    }
}
 
export default MyOrder;